export default __webpack_public_path__ + "static/media/logo-text.20562a10.png";